<template>
  <FullScreenLayout>
    <FullScreenLayoutContent full-width>
      <template #header>
        <DialogHeader v-if="data" :dialog="data.dialog" @close="exitFlow">
          <template #actions>
            <div class="flex flex-row gap-1">
              <DownloadDialogButton
                :dialog-id="data.dialog.id"
                :dialog-phase="data.dialog.phase"
              />
              <BaseTextButton color="tonal" size="M" icon="share" @click="openDialog"
                >Dialog freigeben</BaseTextButton
              >
            </div>
            <BaseDialog type="basic" :is-open="isOpen" @close="closeDialog">
              <div class="flex w-full items-center justify-center py-6">
                <BaseShapeMask shape="8-leaf-clover" animation="spin">
                  <BaseMemberAvatar size="128" :member="data.dialog.coach" />
                </BaseShapeMask>
              </div>
              <h2 class="text-headline-medium mb-2">Möchtest du den Dialog freigeben?</h2>
              <p class="text-body-large">
                {{ $t('dialog.release.coachDescription') }}
              </p>
              <div
                class="bg-secondary-container text-on-secondary-container rounded-medium mt-8 p-3"
              >
                <h4 class="text-title-medium">
                  Dieser Schritt kann nicht rückgängig gemacht werden.
                </h4>
              </div>

              <div
                v-if="unfinishedTopics.length > 0"
                class="bg-error-container text-on-error-container rounded-medium mt-2 p-3"
              >
                <h4 class="text-title-medium mb-1">
                  Schliesse erst alle Themen ab, bevor du den Dialog freigeben kannst.
                </h4>
                <ul class="mt-4 ml-1 flex flex-col gap-1">
                  <li
                    v-for="feedbackTopic in unfinishedTopics"
                    :key="feedbackTopic.id"
                    class="flex flex-row"
                  >
                    <BaseIcon size="18" class="mr-2">{{ feedbackTopic.icon }}</BaseIcon>
                    <span class="text-body-medium">{{ feedbackTopic.title }}</span>
                  </li>
                </ul>
              </div>
              <div
                v-if="unfinishedSurveys.length > 0"
                class="bg-error-container text-on-error-container rounded-medium mt-2 p-3"
              >
                <h4 class="text-title-medium">Nicht abgeschlossene Umfragen ausgewählt.</h4>
                <p class="text-body-medium">
                  Du hast Umfragen ausgwählt, die noch nicht abgeschlossen sind.
                </p>
              </div>
              <template #dismiss
                ><BaseTextButton size="M" @click="closeDialog">{{
                  $t('common.cancel')
                }}</BaseTextButton></template
              >
              <template #confirm
                ><BaseTextButton
                  size="M"
                  @click="releaseDialog"
                  :disabled="!canReleaseDialog || releaseStatus == ApiRequestStatus.Loading"
                  >Dialog freigeben</BaseTextButton
                ></template
              >
            </BaseDialog>
          </template>
        </DialogHeader>
      </template>
      <LoadingWrapper :state="status"> </LoadingWrapper>
    </FullScreenLayoutContent>
  </FullScreenLayout>
</template>
<script lang="ts" setup>
  import FullScreenLayout from '../../../core/components/layouts/FullScreenLayout.vue'
  import FullScreenLayoutContent from '../../../core/components/layouts/FullScreenLayoutContent.vue'
  import { useCoacheePrepareDialog } from '../composable/use-coachee-prepare-dialog'
  import LoadingWrapper from '../../../core/components/loading/LoadingWrapper.vue'
  import BaseTextButton from '../../../core/components/base/button/text-button/BaseTextButton.vue'
  import BaseDialog from '../../../core/components/base/dialog/BaseDialog.vue'
  import { useDialog } from '../../../core/components/base/dialog/use-dialog'
  import DialogHeader from '../components/DialogHeader.vue'
  import BaseShapeMask from '../../../core/components/base/shapes/BaseShapeMask.vue'
  import BaseMemberAvatar from '../../../core/components/base/avatar/BaseMemberAvatar.vue'
  import { computed } from 'vue'
  import { DialogPhase } from '../../../core/models/dialog/dialog'
  import { useUserStore } from '../../../stores/user.store'
  import { useFlowHistory } from '@/core/composables/use-flow-history'
  import BaseIcon from '@/core/components/base/icon/BaseIcon.vue'
  import DownloadDialogButton from '../components/DownloadDialogButton.vue'
  import { ApiRequestStatus } from '@/core/models/api/api-request-status'

  const {
    status,
    data,
    releaseDialog,
    releaseStatus,
    unfinishedTopics,
    unfinishedSurveys,
    canReleaseDialog,
  } = useCoacheePrepareDialog()

  const { isOpen, openDialog, closeDialog } = useDialog()

  const { user } = useUserStore()

  const { exitFlow } = useFlowHistory({ name: 'dialog' })

  const isEditable = computed(() => {
    return (
      (data.value?.dialog.phase == DialogPhase.Feedback &&
        data.value.dialog.coachee.id == user.id) ||
      (data.value?.dialog.phase != DialogPhase.Conducted && data.value.dialog.coach.id == user.id)
    )
  })
</script>
